<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.download }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="typeList" v-model="form.type" :label="labels.type" item-text="label"
                            item-value="value" data-vv-name="form.type" :data-vv-as="labels.type"
                            :error-messages="errors.collect('form.type')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                            :error-messages="errors.collect('form.tranDateFrom')"
                            v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                            :error-messages="errors.collect('form.tranDateTo')"
                            v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="monthList" v-model="form.month" :label="labels.month"
                            item-text="label" item-value="value" data-vv-name="form.month" :data-vv-as="labels.month"
                            :error-messages="errors.collect('form.month')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="yearList" v-model="form.year" :label="labels.year" item-text="label"
                            item-value="value" data-vv-name="form.year" :data-vv-as="labels.year"
                            :error-messages="errors.collect('form.year')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-checkbox v-model="form.excRI" :label="labels.excRI"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Department -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="allSelectedList" v-model="form.dept" :label="labels.dept"
                            item-text="label" item-value="value" data-vv-name="dept" :data-vv-as="labels.dept"
                            :error-messages="errors.collect('dept')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-if="form.dept === 'Selected'">
                          <v-autocomplete :items="deptList" v-model="form.selectedDept" :label="labels.selectedDept"
                            item-text="label" item-value="value" multiple data-vv-name="selectedDept"
                            :data-vv-as="labels.selectedDept" :error-messages="errors.collect('selectedDept')"
                            v-validate="'required'" :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-else></v-flex>

                        <!-- Branch -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="allSelectedList" v-model="form.branch" :label="labels.branch"
                            item-text="label" item-value="value" data-vv-name="branch" :data-vv-as="labels.branch"
                            :error-messages="errors.collect('branch')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-if="form.branch === 'Selected'">
                          <v-autocomplete :items="branchList" v-model="form.selectedBranch"
                            :label="labels.selectedBranch" item-text="label" item-value="value" multiple
                            data-vv-name="selectedBranch" :data-vv-as="labels.selectedBranch"
                            :error-messages="errors.collect('selectedBranch')" v-validate="'required'"
                            :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-else></v-flex>

                        <!-- Direct / RI Inwards -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="dRiList" v-model="form.dRi" :label="labels.dRi" item-text="label"
                            item-value="value" data-vv-name="dRi" :data-vv-as="labels.dRi"
                            :error-messages="errors.collect('dRi')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.forClaimsOnly }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Recovery Payment Category -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="allSelectedList" v-model="form.paymentCategory"
                            :label="labels.paymentCategory" :disabled="this.form.type === 'P'" item-text="label"
                            item-value="value" data-vv-name="paymentCategory" :data-vv-as="labels.paymentCategory"
                            :error-messages="errors.collect('paymentCategory')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-if="form.paymentCategory === 'Selected'">
                          <v-autocomplete :items="paymentCategoryList" v-model="form.selectedPaymentCategory"
                            :label="labels.selectedPaymentCategory" item-text="label" item-value="value" multiple
                            data-vv-name="selectedPaymentCategory" :data-vv-as="labels.selectedPaymentCategory"
                            :error-messages="errors.collect('selectedPaymentCategory')" v-validate="'required'"
                            :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-else></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-checkbox v-model="form.printParam" :label="labels.printParam" :disabled="this.form.format === 'TXT'"></v-checkbox>
        <v-flex xs12 sm12 md12 lg12>
          <v-layout class="d-flex align-center">
            <v-btn class="mr-3" color="primary" type="submit" :loading="processing" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{ labels.export }}
            </v-btn>
            <v-btn-toggle class="mr-10" dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      labels: {
        download: 'Selection Criteria',
        type: 'Type of Motor Transactions',
        tranDateFrom: 'Period From*',
        tranDateTo: 'Period To*',
        month: 'For Reporting Month',
        year: 'Reporting Year',
        selectedBranch: 'Selected Branch',
        selectedDept: 'Selected Department',
        branch: 'Branch',
        dept: 'Department',
        selectionCriteria: 'Filters',
        forClaimsOnly: 'For Claims Only',
        excRI: 'Exclude RI Inwards',
        dRi: 'Direct / RI Inwards',
        paymentCategory: 'Recovery Payment Category',
        selectedPaymentCategory: 'Selected Recovery Payment Category',
        export: 'Export To',
        printParam: 'Print Runtime Parameters'
      },
      form: {
        type: 'CP',
        tranDateFrom: null,
        tranDateTo: null,
        month: null,
        year: null,
        branch: 'All',
        selectedBranch: null,
        dept: 'All',
        selectedDept: null,
        excRI: false,
        dRi: 'Direct',
        paymentCategory: 'All',
        selectedPaymentCategory: null,
        format: 'TXT',
        printParam: true
      },
      today: new Date(),
      typeList: [
        {
          label: 'Claims and Policies',
          value: 'CP'
        },
        {
          label: 'Claims',
          value: 'C'
        },
        {
          label: 'Policies',
          value: 'P'
        }
      ],
      monthList: [],
      yearList: [],
      loading: false,
      processing: false,
      claimsProcessing: false,
      policiesProcessing: false,
      showErrorDialog: false,
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      supportedFormat: ['TXT', 'PDF'],
      branchList: [],
      deptList: [],
      paymentCategoryList: [],
      dRiList: [
        {
          label: 'Both',
          value: 'Both'
        },
        {
          label: 'Direct',
          value: 'Direct'
        },
        {
          label: 'RI Inwards',
          value: 'Inwards'
        }
      ],
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.form.tranDateFrom !== '' && this.form.tranDateFrom !== null && this.form.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.form.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null && this.form.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    claimsProcessing: function (value) {
      if (this.form.type === 'C' || (this.form.type === 'CP' && this.policiesProcessing === value)) {
        this.processing = value
      }
    },
    policiesProcessing: function (value) {
      if (this.form.type === 'P' || (this.form.type === 'CP' && this.claimsProcessing === value)) {
        this.processing = value
      }
    },
    'form.format': function () {
      if (this.form.format === 'TXT') {
        this.form.printParam = false
      }
    },
    'form.type': function () {
      if (this.form.type === 'P') {
        this.form.paymentCategory = 'All'
      }
    }
  },
  methods: {
    doInit() {
      this.setMonthList()
      this.setYearList()
      this.form.tranDateTo = this.today
      this.form.month = this.monthList[0].value // 01
      this.form.year = this.yearList[1].value // current year
      this.getMotorTransactionsGIA()
    },
    async getMotorTransactionsGIA() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.motorTransactionsGIA
      if (apiUrl) {
        try {
          this.loading = true
          const { data } = await this.$http.get(apiUrl)
          this.branchList = data.branchList
          this.deptList = data.deptList
          this.paymentCategoryList = data.paymentCategoryList
        } catch (err) {
          this.message(err.response.data)
        } finally {
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    setMonthList() {
      for (let i = 1; i <= 12; i++) {
        const month = i.toString().padStart(2, '0')
        this.monthList.push({
          label: month,
          value: month
        })
      }
    },
    setYearList() {
      const currentYear = this.today.getFullYear()
      for (let i = -1; i <= 1; i++) {
        const year = currentYear + i
        this.yearList.push({
          label: year,
          value: year
        })
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.form.type.includes('C')) {
            this.doExportClaims()
          }
          if (this.form.type.includes('P')) {
            this.doExportPolicies()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExportClaims() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportMotorTransactionsClaimsGIA
      if (apiUrl) {
        try {
          this.claimsProcessing = true
          await this.$http.post(apiUrl, this.form)
        } catch (err) {
          this.message(err.response.data)
        } finally {
          this.claimsProcessing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doExportPolicies() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportMotorTransactionsPoliciesGIA
      if (apiUrl) {
        try {
          this.policiesProcessing = true
          await this.$http.post(apiUrl, this.form)
        } catch (err) {
          this.message(err.response.data)
        } finally {
          this.policiesProcessing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style></style>
